module.exports = __webpack_public_path__ + "img/aliado-derek.3202dca9.png";